import { mergeClasses } from '@/utils';

import { Button } from '@/components/common';

import { BUTTON_GROUP_VARIANTS } from './ButtonGroup.constants';
import { IButtonGroup, ICustomButtonGroup } from './ButtonGroup.interfaces';

const ButtonGroup = ({ className, orientation, ...props }: IButtonGroup) => {
  return (
    <div
      role="group"
      data-slot="button-group"
      data-orientation={orientation}
      className={mergeClasses(BUTTON_GROUP_VARIANTS({ orientation }), className)}
      {...props}
    />
  );
};

const CustomButtonGroup = ({
  className,
  orientation,
  label,
  buttonNames,
  required = false,
  selectedIndex,
  buttonClass,
  error,
  onSelect,
  ...props
}: ICustomButtonGroup) => {
  return (
    <div className={mergeClasses('flex flex-col gap-1.5 border-neutral-n4 w-full', className)}>
      {label && (
        <label className="text-sm font-semibold text-neutral-n9">
          {label}
          {required && <span className="ml-1 text-semantic-error-base">*</span>}
        </label>
      )}

      <ButtonGroup className={mergeClasses('h-10', className)} orientation={orientation} {...props}>
        {buttonNames.map((buttonName) => (
          <Button
            key={buttonName.value}
            variant={selectedIndex === buttonName.value ? 'primary' : 'secondary'}
            className={mergeClasses(
              'rounded-soft font-semibold text-sm min-w-[120px]',
              error && '!border-semantic-error-base',
              buttonClass,
            )}
            onClick={() => onSelect(buttonName.value)}
          >
            {buttonName.name}
          </Button>
        ))}
      </ButtonGroup>

      {error && <p className="text-xs text-semantic-error-base">{error}</p>}
    </div>
  );
};

export { ButtonGroup, CustomButtonGroup };
